import React from 'react';
import PropTypes from 'prop-types';

import round from 'lodash/round';

import { connect } from 'react-redux';

import Value from './value';

export function PercentValue({ deal, name, value, ...props }) {
  value = value || deal[name];
  if (value != null) {
    value = `${round(value, 2)}%`;
  }

  return <Value {...props} name={name} value={value} />;
}

PercentValue.propTypes = {
  deal: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.number,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(PercentValue);
